import React from 'react'
import { DialogActions } from '@mui/material'
import ThemeConfig from '../../theme/ThemeConfig'

const DialogFooter = props => {
  const { actionContent } = props

  return <DialogActions theme={ThemeConfig}>{actionContent}</DialogActions>
}

export default DialogFooter
